import { curveNatural } from 'd3-shape';
import '@d3fc/d3fc-element';
import { AnySelection, seriesSvgLine } from '@d3fc/d3fc-series';
import { derivePrice } from 'widgets/fillsGraph/fillsGraphData';
import { deriveTime } from 'utils/components/TimeSeriesChart/TimeSeriesChartData';

export const priceLine = seriesSvgLine()
    .crossValue(deriveTime)
    .mainValue(derivePrice)
    .curve(curveNatural)
    .decorate((s: AnySelection) => s.classed('priceLine', true));
